const zsHybridConfig = {
  plat: 'dxstAPP',
  zpID: 'PKD-DXST'
};

const zsH5Config = {
  plat: 'dxstWAP',
  zpID: 'PKD-DXST-C',
  waitNativeCbkTimeout: 1000 // SDK随端上报时等待回调时间，对随端上报时设置
};
const isProd = process.env.NODE_ENV == 'production';
const isShip = process.env.CI_FE_DEBUG && process.env.CI_FE_DEBUG === 'true';

const zsEnvConfig = {
  debug: !isProd || isShip,
  env: isProd && !isShip ? 'production' : 'development'
};

// H5埋点上报地址 https://log.kuaiduizuoye.com/log/h5_test \ https://nlogtj.zuoyebang.cc/nlogtj/h5_test
const zsH5LogUrl = {
  logUrl:
    isProd && !isShip
      ? 'https://nlog.daxuesoutijiang.com/log/h5_daxuesouti'
      : 'https://log.kuaiduizuoye.com/log/h5_test'
};

const zsSetup = (Vue: any, zs: any) => {
  zs.init();
  Vue.prototype._zs = zs;
  Vue.prototype.zstrack = function (params: Record<string, any>): void {
    try {
      const name = params?.name;
      if (name) {
        delete params.name;
        zs.track(name, { ...params });
      }
    } catch (err) {
      console.log(err);
    }
  };
};

/**
 * 依赖 @zyb-data/stats-hybridh5，适用于即在端内也在端外的H5页面
 * 具体见：http://ued.zuoyebang.cc/documents/stats/#/sdk-import/import-hybridh5
 * @param Vue
 * @param zs
 */
export function zsHybridH5Setup(Vue: unknown, zs: Record<any, any>): void {
  zs.config({
    ...zsHybridConfig,
    ...zsEnvConfig,
    ...zsH5LogUrl
  });
  zsSetup(Vue, zs);
}

/**
 * 依赖 @zyb-data/stats-h5，适用于只在端外的H5页面
 * 具体见：http://ued.zuoyebang.cc/documents/stats/#/sdk-import/import-h5
 * @param Vue
 * @param zs
 */
export function zsH5Setup(Vue: unknown, zs: Record<any, any>): void {
  zs.config({
    ...zsH5Config,
    ...zsEnvConfig,
    ...zsH5LogUrl
  });
  zsSetup(Vue, zs);
}

/**
 * 依赖@zyb-data/stats-hybrid，适用于只在端内的H5页面
 * 具体见：http://ued.zuoyebang.cc/documents/stats/#/sdk-import/import-hybrid
 * @param Vue
 * @param zs
 */
export function zsHybridSetup(Vue: unknown, zs: Record<any, any>): void {
  zs.config({
    ...zsHybridConfig,
    ...zsEnvConfig
  });
  zsSetup(Vue, zs);
}
